import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

import GenericCheckBox from '../controls/GenericCheckbox';
import DATE_VARIALBES from '../../config/dateVariables';

const FilterHeader = ({
    filter,
    setFilter,
    minDate,
    maxDate,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    showRevoked,
    setShowRevoked,
    statusFilterOptions,
    statusFilter,
    setStatusFilter
}) => {
    const [translate] = useTranslation();
    const datePicker = useCallback((isStart) => {
        return <DatePicker
            selected={isStart ? startDate : endDate}
            onChange={(newDate) => {
                setFilter("custom");

                if (isStart) {
                    setStartDate(newDate);
                } else {
                    setEndDate(newDate);
                }
            }}
            showTimeSelect
            dateFormat="yyyy-MM-dd HH:mm"
            minDate={isStart ? minDate : startDate}
            maxDate={isStart ? endDate : maxDate}
        />
    }, [startDate, endDate, minDate, maxDate, setEndDate, setStartDate, setFilter]);

    const renderStatusButtons = useMemo(() =>
        statusFilterOptions.map((option) =>
            <Button
                key={option.value}
                variant={`${statusFilter.includes(option.value) ? 'primary' : 'outline-primary'}`}
                size='sm'
                className='me-1'
                onClick={() => {
                    setStatusFilter(prev => {
                        const index = prev.indexOf(option.value);
                        if (index > -1) {
                            prev.splice(index, 1);
                        }
                        else {
                            prev.push(option.value);
                        }

                        return [...prev];
                    })
                }}
            >
                {option.displayValue}
            </Button>)
        , [setStatusFilter, statusFilter, statusFilterOptions]);

    return (
        <div className="row gx-1 mb-1">
            <div className="col-auto">
                <Button
                    variant="outline-primary"
                    size="sm"
                    active={filter === "90d"}
                    onClick={() => {
                        setFilter("90d");
                        setStartDate(
                            new Date(Date.now() - DATE_VARIALBES.NINETY_DAYS_IN_MS)
                        );
                        setEndDate(new Date());
                    }}
                >
                    {translate("OTM_NOTIFICATIONS_LAST_90D")}
                </Button>
            </div>
            <div className="col-auto">
                <Button
                    variant="outline-primary"
                    size="sm"
                    active={filter === "24h"}
                    onClick={() => {
                        setFilter("24h");
                        setStartDate(
                            new Date(Date.now() - DATE_VARIALBES.TWENTY_FOUR_HOURS_IN_MS)
                        );
                        setEndDate(new Date());
                    }}
                >
                    {translate("OTM_NOTIFICATIONS_LAST_24H")}
                </Button>
            </div>
            <div className="col-auto">
                <Button
                    variant="outline-primary"
                    size="sm"
                    active={filter === "1h"}
                    onClick={() => {
                        setFilter("1h");
                        setStartDate(new Date(Date.now() - DATE_VARIALBES.ONE_HOUR_IN_MS));
                        setEndDate(new Date());
                    }}
                >
                    {translate("OTM_NOTIFICATIONS_LAST_1H")}
                </Button>
            </div>
            <div className="col-auto">
                <span className="me-1">{translate("OTM_NOTIFICATIONS_FROM")}</span>
                {datePicker(true)}
            </div>
            <div className="col-auto">
                <span className="me-1">{translate("OTM_NOTIFICATIONS_TO")}</span>
                {datePicker(false)}
            </div>
            <div className='col-auto'>
                {renderStatusButtons}
            </div>
            {showRevoked !== undefined && setShowRevoked !== undefined && <div className="col-auto ms-auto d-flex">
                <GenericCheckBox
                    label={translate("OTM_SHOW_REVOKED")}
                    initialValue={showRevoked}
                    onChange={() => setShowRevoked(prev => !prev)}
                    css={{ toggle: "ms-2" }}
                />
            </div>}
        </div>
    );
}

export default FilterHeader;